import React from "react";
import { Steps } from "../../../../components/Steps";
import SetExtraIngredients from "../SetExtraIngredients";
import SetAvailabilityStep from "../../SetAvailabilityStep";

import styles from "../../../../../styles/add-category.module.scss";
import { Button } from "../../../../components/Button";
import { Icon } from "../../../../components/core/Icon";
import SelectSizeStep from "../SelectSizeStep";
import SetSizesStep from "../SetSizesStep";
import SetPizzaEdgesStep from "../SetPizzaEdgesStep";
import SetPizzaDoughsStep from "../SetPizzaDoughsStep";

const StepNames = {
    NAME_AND_NUM_SIZES: 'NAME_AND_SIZE',
    SIZES: 'SIZES',
    EDGES: 'EDGES',
    DOUGHS: 'DOUGHS',
    EXTRA_INGREDIENTS: 'EXTRA_INGREDIENTS',
    AVAILABILITY: 'AVAILABILITY'
}

export class CategoryPizza extends React.Component {

    state = {
        category: {
            type: 'category',
            name: null,
            mode: null,
            single_size: false,
            default_sizes: undefined,
            show: true,
            highlight: false,
            availability: null,
            extra_ingredients: [],
            doughs: [],
            edges: [],
            items: [],
            sizes: [],
        },
        steps: 6,
        step: StepNames.NAME_AND_NUM_SIZES,
        currentStep: 1,
        disabled: true
    }

    componentDidMount() {
        const { category } = this.props;
        this.setState({ category });
    }

    onChangeCategory(values) {
        const { category } = this.state;
        this.setState({
            category: { ...category, ...values }
        }, this.validateStep.bind(this));
    }

    validateStep() {
        const { step, category } = this.state;
        switch (step) {
            case StepNames.NAME_AND_NUM_SIZES:
                return this.setState({ disabled: !category || !category.name || category.sizes.length == 0 });
            case StepNames.SIZES:
                return this.setState({
                    disabled: category.sizes.reduce((f, size) => (f || !size.name || !size.max), false)
                })
            case StepNames.EDGES:
                return this.setState({
                    disabled: (
                        category.edges.length > 0
                        && !(category.edges.reduce((previousEdge, edge) => {
                            return previousEdge && !!edge.name && edge.sizes.reduce((previousEdgeSize, edgeSize) => {
                                return previousEdgeSize && !!edgeSize.name && !!edgeSize.price && Number(String(edgeSize.price)) != NaN
                            }, true)
                        }, true))
                    )
                })
            case StepNames.DOUGHS:
                return this.setState({
                    disabled: (
                        category.doughs.length > 0
                        && !(category.doughs.reduce((previousDough, dough) => {
                            return previousDough && !!dough.name && dough.sizes.reduce((previousDoughSize, doughSize) => {
                                return previousDoughSize && !!doughSize.name && !!doughSize.price && Number(String(doughSize.price)) != NaN
                            }, true)
                        }, true))
                    )
                })
            case StepNames.EXTRA_INGREDIENTS:
                return this.setState({
                    disabled: (
                        category.extra_ingredients.length > 0
                        && !(category.extra_ingredients.reduce((previousExtra, extra) => {
                            return previousExtra && !!extra.name && extra.sizes.reduce((previousExtraSize, extraSize) => {
                                return previousExtraSize && !!extraSize.name && !!extraSize.price && Number(String(extraSize.price)) != NaN
                            }, true)
                        }, true))
                    )
                })
            case StepNames.AVAILABILITY:
                return this.setState({
                    disabled: category.availability === null ? false : (
                        category.availability.daysOfTheWeek == 0 || !category.availability.periods.reduce((previousPeriod, period) => {
                            return previousPeriod && (!!period.beginTime && !!period.endTime)
                        }, true)
                    )
                });
        }
    }

    getCorrectSize(category) {
        const { sizes } = category;

        //Adicionar tamanhos novos nos ingrediente extras
        for (const size of sizes) {
            for (const edge of category.edges) {
                const edgeSizeRefIds = edge.sizes.map((s) => s.ref_id)
                if(!edgeSizeRefIds.includes(size.ref_id)) {
                    edge.sizes.push(size)
                }
            }
            
            for (const dough of category.doughs) {
                const doughSizeRefIds = dough.sizes.map((s) => s.ref_id)
                if(!doughSizeRefIds.includes(size.ref_id)) {
                    dough.sizes.push(size)
                }
            }

            for (const extra of category.extra_ingredients) {
                const extraSizeRefIds = extra.sizes.map((s) => s.ref_id)
                if(!extraSizeRefIds.includes(size.ref_id)) {
                    extra.sizes.push(size)
                }
            }
        }

        //Atualizar os tamanhos dos ingredientes extras já pré-existentes
        for (const size of sizes) {
            for (const edge of category.edges) {
                for (const edgeSize of edge.sizes) {
                    if(edgeSize.ref_id == size.ref_id) {
                        edgeSize.name = size.name;
                    }
                }
            }
            
            for (const dough of category.doughs) {
                for (const doughSize of dough.sizes) {
                    if(doughSize.ref_id == size.ref_id) {
                        doughSize.name = size.name;
                    }
                }
            }
            
            for (const extra of category.extra_ingredients) {
                for (const extraSize of extra.sizes) {
                    if(extraSize.ref_id == size.ref_id) {
                        extraSize.name = size.name;
                    }
                }
            }
        }
        //Remover os que deixaram de existir
        const sizesRefIds = sizes.map((s) => s.ref_id);
        for (const edge of category.edges) {
            edge.sizes = edge.sizes.filter((s) => sizesRefIds.includes(s.ref_id));
        }
        
        for (const dough of category.doughs) {
            dough.sizes = dough.sizes.filter((s) => sizesRefIds.includes(s.ref_id));
        }

        for (const extra of category.extra_ingredients) {
            extra.sizes = extra.sizes.filter((s) => sizesRefIds.includes(s.ref_id));
        }

        return category;
    }

    nextStep() {
        const { step, category } = this.state;

        switch (step) {
            case StepNames.NAME_AND_NUM_SIZES:
                return this.setState({
                    step: StepNames.SIZES,
                    currentStep: 2,
                    disabled: true,
                    category: {
                        ...category,
                        single_size: category.sizes.length == 1
                    }
                }, this.validateStep.bind(this));
            case StepNames.SIZES:
                return this.setState({
                    step: StepNames.EDGES,
                    currentStep: 3,
                    category: this.getCorrectSize(category),
                    disabled: true
                }, this.validateStep.bind(this));
            case StepNames.EDGES:
                return this.setState({
                    step: StepNames.DOUGHS,
                    currentStep: 4,
                    disabled: true
                }, this.validateStep.bind(this));
            case StepNames.DOUGHS:
                return this.setState({
                    step: StepNames.EXTRA_INGREDIENTS,
                    currentStep: 5,
                    disabled: true
                }, this.validateStep.bind(this));
            case StepNames.EXTRA_INGREDIENTS:
                return this.setState({
                    step: StepNames.AVAILABILITY,
                    currentStep: 6,
                    disabled: true
                }, this.validateStep.bind(this));
            case StepNames.AVAILABILITY:
                return false;
        }
    }

    prevStep() {
        const { step, category } = this.state;
        const { onPrev } = this.props;

        switch (step) {
            case StepNames.NAME_AND_NUM_SIZES:
                return onPrev && onPrev();
            case StepNames.SIZES:
                return this.setState({
                    step: StepNames.NAME_AND_NUM_SIZES,
                    currentStep: 1,
                    disabled: false
                }, this.validateStep.bind(this));
            case StepNames.EDGES:
                return this.setState({
                    step: StepNames.SIZES,
                    currentStep: 2,
                    disabled: false
                }, this.validateStep.bind(this));
            case StepNames.DOUGHS:
                return this.setState({
                    step: StepNames.EDGES,
                    currentStep: 3,
                    disabled: false
                }, this.validateStep.bind(this));
            case StepNames.EXTRA_INGREDIENTS:
                return this.setState({
                    step: StepNames.DOUGHS,
                    currentStep: 4,
                    disabled: false
                }, this.validateStep.bind(this));
            case StepNames.AVAILABILITY:
                return this.setState({
                    step: StepNames.EXTRA_INGREDIENTS,
                    currentStep: 5,
                    disabled: false
                }, this.validateStep.bind(this));

        }
    }


    render() {
        const { onSave } = this.props;
        const { currentStep, category, step, steps, disabled } = this.state;


        const mountPayload = this.onChangeCategory.bind(this);
        const prevStep = this.prevStep.bind(this);
        const nextStep = this.nextStep.bind(this);

        return (
            <>
                <div className={styles.scrollContainer}>
                    <Steps steps={steps} currentStep={currentStep}>
                        {step === StepNames.NAME_AND_NUM_SIZES && (<SelectSizeStep category={category} mountPayload={mountPayload} />)}
                        {step === StepNames.SIZES && (<SetSizesStep category={category} onChange={mountPayload} />)}
                        {step === StepNames.EDGES && (<SetPizzaEdgesStep category={category} onChange={mountPayload} />)}
                        {step === StepNames.DOUGHS && (<SetPizzaDoughsStep category={category} onChange={mountPayload} />)}
                        {step === StepNames.EXTRA_INGREDIENTS && (<SetExtraIngredients category={category} mountPayload={mountPayload} />)}
                        {step === StepNames.AVAILABILITY && (<SetAvailabilityStep item={category} mountPayload={mountPayload} />)}
                    </Steps>
                </div>
                <div className={styles.footer}>
                    <Button design="default-icon" onClick={prevStep}>
                        <Icon name="long-arrow-left" size="xl" />
                    </Button>

                    {step === StepNames.AVAILABILITY ? (
                        <Button design="primary-icon" onClick={() => !disabled && onSave && onSave(category)} disabled={disabled}>
                            <Icon name="check" size="xl" />
                        </Button>
                    ) : (
                        <Button design="primary-icon" onClick={nextStep} disabled={disabled}>
                            <Icon name="long-arrow-right" size="xl" />
                        </Button>
                    )}
                </div>
            </>
        );
    }
}